import React, { useEffect } from "react";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import { AUDITORY_MODEL, PAYMENT_MODEL } from "../models/model";
import { SectionPayment } from "../components/SectionPayment";
import { SectionAction } from "../components/SectionAction";
import { PlansProvider } from "../../step-plans/context/PlansContext";
import { getProductOptions } from '@/utils/product'
import helpers from '@/utils/helpers'
import useScrollToPosition from '@/hooks/useScrollToPosition'

const StepPayment = () => {
  useScrollToPosition();
  const { digitalDataProductName } = getProductOptions();

  const callAnalyticsAction = () => {
    helpers.getTagAction(
      digitalDataProductName,
      "Resumen y pago",
      "click",
      "Ver detalle",
      "trackAction"
    );
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem("checkoutError");
      localStorage.removeItem("checkoutSuccess");
    };
  }, []);

  return (
    <PlansProvider>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <SectionPayment {...PAYMENT_MODEL} />
      <SectionAction analyticsDetailAction={callAnalyticsAction} />
    </PlansProvider>
  );
};

export default StepPayment;
